const GOOGLE_MEASUREMENT_ID = "G-J1MFHDJMTW";
const GOOGLE_TAG_SCRIPT_ID = "equity-replay-google-tag";

type DataLayerEntry = IArguments | unknown[];
type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: DataLayerEntry[];
    gtag?: Gtag;
    __equityReplayAnalyticsInitialized?: boolean;
    __equityReplayLastTrackedNavigation?: string;
  }
}

export function isAnalyticsHost(hostname: string) {
  return hostname === "equityreplay.com" || hostname === "www.equityreplay.com";
}

export function safePagePath(pathname: string) {
  const path = pathname.split(/[?#]/, 1)[0] || "/";
  return path.startsWith("/") ? path : `/${path}`;
}

export function safeNavigationPath(pathname: string) {
  const path = pathname.split("#", 1)[0] || "/";
  return path.startsWith("/") ? path : `/${path}`;
}

export function initializeAnalytics() {
  if (typeof window === "undefined" || !isAnalyticsHost(window.location.hostname) || window.__equityReplayAnalyticsInitialized) return;

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = window.gtag ?? function () {
    window.dataLayer?.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_MEASUREMENT_ID, {
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });

  if (!document.getElementById(GOOGLE_TAG_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GOOGLE_TAG_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.__equityReplayAnalyticsInitialized = true;
}

export function trackPageView(pathname: string, title: string, navigationPath = pathname) {
  if (typeof window === "undefined" || !isAnalyticsHost(window.location.hostname)) return;
  initializeAnalytics();

  const pagePath = safePagePath(pathname);
  const pageTitle = title.trim() || "Equity Replay";
  const navigationKey = safeNavigationPath(navigationPath);
  if (window.__equityReplayLastTrackedNavigation === navigationKey || !window.gtag) return;
  window.__equityReplayLastTrackedNavigation = navigationKey;
  window.gtag("event", "page_view", {
    page_title: pageTitle,
    page_location: `${window.location.origin}${pagePath}`,
    page_path: pagePath,
  });
}
